
import VueSlickCarousel from 'vue-slick-carousel';
import ServiceBarIcon from '../ServiceBarIcon.vue';
import DesktopServiceBarSlide from './DesktopServiceBarSlide.vue';
import ResponsiveAnimatedLine from './ResponsiveAnimatedLine.vue';
import IconBrand from '~/components/icons/IconBrand.vue';
import IconDeliver from '~/components/icons/IconDeliver.vue';
import IconMake from '~/components/icons/IconMake.vue';
import IconMakeActive from '~/components/icons/IconMakeActive.vue';
import IconPlan from '~/components/icons/IconPlan.vue';
import IconSource from '~/components/icons/IconSource.vue';
import IconStore from '~/components/icons/IconStore.vue';
import IconPlanActive from '~/components/icons/IconPlanActive.vue';
import IconSourceActive from '~/components/icons/IconSourceActive.vue';
import IconDeliverActive from '~/components/icons/IconDeliverActive.vue';
import IconStoreActive from '~/components/icons/IconStoreActive.vue';
import IconBrandActive from '~/components/icons/IconBrandActive.vue';

export default {
  components: { ResponsiveAnimatedLine, IconPlan, IconMake, IconMakeActive, IconSource, IconBrand, IconDeliver, IconStore, ServiceBarIcon, VueSlickCarousel, DesktopServiceBarSlide, IconPlanActive, IconSourceActive, IconDeliverActive, IconStoreActive, IconBrandActive },
  data () {
    return {
      current: 0
    };
  },
  methods: {
    handleSlideNavigation (index) {
      // console.log(typeof index);
      if (typeof index !== 'number') { return; }
      if (index < 0 || index > 5) { return; }
      if (this.$refs.slider) { this.$refs.slider.goTo(index); }
      this.current = index;
    },
    isActive (index) {
      return this.current === index;
    },
    isLineActive (index) {
      return this.current >= index;
    },
    updateSlide (_o, n) {
      this.current = n;
    }
  }
};
